import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import RegistroDeVisitasForm from "./RegistroDeVisitaForm";

const RegistroDeVisitasModal = ({ toggle, isOpen, clientId, razonSocial, refreshVisitas, dataToEdit }) => {
  return (
    <div style={{ fontFamily: "Nunito" }}>
      <Modal centered size="lg" isOpen={isOpen}>
        <ModalHeader toggle={toggle}>Nuevo Registro de Visita</ModalHeader>
        <ModalBody style={{ backgroundColor: "#f8f8f8", borderRadius: "10px" }}>
          <RegistroDeVisitasForm clientId={clientId} toggle={toggle} razonSocial={razonSocial} refreshVisitas={refreshVisitas} dataToEdit={dataToEdit} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default RegistroDeVisitasModal;
